import React, { useState, useEffect } from 'react';
import { useAuth } from '../Context/AuthContext';

import { Card, Container, Row, Form, Button, Col} from 'react-bootstrap';
import {inputMaxLengths} from '../HelperFunctions/InputMaxLengths';

import { autoID } from '../HelperFunctions/autoID';

import { db } from '../firebase-config';
import { collection, getDocs, doc, setDoc, deleteDoc } from 'firebase/firestore';

import { toast } from 'react-toastify';
import StatusSpinner from '../Components/StatusSpinner';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faCircleMinus } from '@fortawesome/free-solid-svg-icons';
import CreateClientModal from '../Modals/CreateClientModal';

export default function EmployeeClientInformation() {
    const { setShowSpinner, showSpinner } = useAuth();
    const [chosenClient, setChosenClient] = useState({id: ''});
    const [clientInfo, setClientInfo] = useState([]);

    const [createClientModalShow, setCreateClientModalShow] = useState(false);

    const [updateClientButtonStatus, setUpdateClientButtonStatus] = useState('edit');  // edit or save
    // const [selectedInvoice, setSelectedInvoice] = useState('');

    const [emailTooltip, setEmailTooltip] = useState('');
    const [toolTipIndex, setToolTipIndex] = useState(0);
    const [emailTooltipAdditional, setEmailTooltipAdditional] = useState('');
    const [toolTipIndexAdditional, setToolTipIndexAdditional] = useState(0);
    const emailReg = /[A-Za-z0-9._+-]+@[A-Za-z0-9 -]+\.[a-z]{2,}/g;

    // use form ref to clear selection
    const [locationDropDownDOM, setLocationDropDownDOM] = useState(null);

    useEffect(()=>{

        setShowSpinner(true)
        // ------ SEE EMPLOYEE ADMIN SETTINGS PAGE
        // load all clients from database
        getDocs(collection(db, "client_information")).then((snapShot)=>{
            // go through each client and set array of all clientInfo
            let tempClientInfo = [{id: ''}];
            snapShot.forEach((doc)=>{
                tempClientInfo.push({...doc.data(), id: doc.id});
            })
            tempClientInfo.sort((a,b)=>{
                if(a.Customer < b.Customer) return -1;
                if(a.Customer > b.Customer) return 1;
                return 0;
            })
            setClientInfo(tempClientInfo);
            setUpdateClientButtonStatus('edit')
            setShowSpinner(false);
        }).catch((error)=>{
            setShowSpinner(false);
            toast.error(`Error getting client list: ${error.message}`);
        });
        
    }, [setShowSpinner]);

    const findChosenClientInfoFromID = ((id)=>{
        return clientInfo.find((client)=> client.id === id)
    });

    const findChosenClientIndexFromID = ((id)=>{
        return clientInfo.findIndex((client)=> client.id === id);
    })

    const toggleClientButtonStatus = (async ()=>{
        if(updateClientButtonStatus === 'edit'){
            setUpdateClientButtonStatus('save');
        } else if(updateClientButtonStatus === 'save'){

            // save to database
            if(emailTooltip === '' && emailTooltipAdditional === ''){
                // once saved complete update local client info

                // check if truck charge and/or hourly rate is blank - if yes set to 0 at time of saving
                const tempChosenClient = {...chosenClient}
                if(tempChosenClient["Hourly Rate"] === ""){
                    tempChosenClient["Hourly Rate"] = 0;
                }
                if(tempChosenClient["Truck Charge"] === ""){
                    tempChosenClient["Truck Charge"] = 0;
                }
                tempChosenClient["Locations"].forEach((location)=>{
                    if(location["Hourly Rate"] === ""){
                        location["Hourly Rate"] = null;
                    }
                    if(location["Truck Charge"] === ""){
                        location["Truck Charge"] = null;
                    }
                })
                const indexOfIdToChange = clientInfo.findIndex((client)=> client.id === chosenClient.id);
                const tempClientInfo = clientInfo.map((client, index)=>{
                    if(index === indexOfIdToChange){
                        return tempChosenClient;
                    }else{
                        return client;
                    }
                });

                setShowSpinner(true)

                try{
                    await setDoc(doc(db, "client_information", tempChosenClient.id), tempChosenClient);
                    toast.success(`Client ${tempChosenClient.Customer} has been updated`);
                    setChosenClient(tempChosenClient);
                    setClientInfo(tempClientInfo);
                }catch(error){
                    toast.error(`Update client info failed: ${error.message}`)
                }

                setShowSpinner(false)

                setUpdateClientButtonStatus('edit');
            }else{
                toast.error('Must be a valid email address');
            }
        }
    });

    const updateChosenClient = ((infoIdentifier, info, type="text", index=undefined)=>{
        // first level strings
        if(index === undefined){
            setChosenClient({
                ...chosenClient,
                [infoIdentifier]: type === "number" ? 
                        info !== "" ?
                            parseFloat(info)
                        :
                            ""
                    : 
                        info
            });
        }
        // second level array list (locations, invoices, etc.)
        if(index !== undefined){
            if(chosenClient?.["Locations"]?.[index]/*?.[infoIdentifier]*/ !== undefined){
                let newInfo = {
                    ...chosenClient,
                }
                newInfo["Locations"] = chosenClient["Locations"].map((old, oldIndex)=>{
                    if(oldIndex === index){
                        return {
                            ...old,
                            [infoIdentifier]: type === "number" ? 
                                    info !== "" ?
                                        parseFloat(info)
                                    :
                                        ""
                                : 
                                    info
                        }
                    }else{
                        return old;
                    }
                })
                setChosenClient(newInfo);
            }else{
                toast.error('Could not update client: undefined');
            }
            
        }
    });

    const updateChosenClientAdditionalContacts = ((infoIdentifier, info, type="text", locationIndex, additionalIndex)=>{
        if(locationIndex !== undefined){
            if(chosenClient?.["Locations"]?.[locationIndex]?.["Additional Contacts"]?.[additionalIndex]?.[infoIdentifier] !== undefined){
                let newInfo = {
                    ...chosenClient,
                }
                newInfo["Locations"][locationIndex]["Additional Contacts"] = chosenClient["Locations"][locationIndex]["Additional Contacts"].map((old, oldIndex)=>{
                    if(oldIndex === additionalIndex){
                        return {
                            ...old,
                            [infoIdentifier]: type === "number" ? 
                                    info !== "" ?
                                        parseFloat(info)
                                    :
                                        ""
                                : 
                                    info
                        }
                    }else{
                        return old;
                    }
                })
                setChosenClient(newInfo);
            }else{
                toast.error('Could not update client: undefined');
            }
            
        }
    });

    const addChosenClientArray = ((infoIdentifier)=>{
        if(chosenClient?.[infoIdentifier] !== undefined){
            setChosenClient({
                ...chosenClient,
                [infoIdentifier]: [...chosenClient[infoIdentifier], {
                    "Additional Contacts": [],
                    "Client Name": "",
                    "Email Address": "",
                    "Hourly Rate": null,
                    "Invoices": [],
                    "Address": "",
                    "Phone Number": "",
                    "Truck Charge": null,
                    "id": autoID()
                }],
            })
        }else{
            toast.error('Could not update client: undefined');
        }
    });
    const addChosenClientArrayAdditionalContact = ((infoIdentifier, index, additionalIdentifier)=>{
        let tempClient = {...chosenClient};
        if(tempClient?.[infoIdentifier]?.[index]?.[additionalIdentifier] === undefined){
            tempClient[infoIdentifier][index][additionalIdentifier] = [];
        }
        if(tempClient?.[infoIdentifier]?.[index]?.[additionalIdentifier] !== undefined){
            //setChosenClient
            const tempAddition = [...tempClient[infoIdentifier][index][additionalIdentifier], {
                "Client Name": "",
                "Email Address": "",
                "Phone Number": "",
            }];

            const tempLocation = {
                ...tempClient[infoIdentifier][index],
                [additionalIdentifier]: [...tempAddition]
            }

            let tempLocations = [...tempClient[infoIdentifier]];
            tempLocations[index] = tempLocation;
            
            setChosenClient({
                ...tempClient,
                [infoIdentifier]: tempLocations
            });
            
        }else{
            toast.error('Could not update client: undefined');
        }
    });

    const removeChosenClientArray = (infoIdentifier, index) => {
        if(chosenClient?.[infoIdentifier] !== undefined){
            let tempChosenClient = {
                ...chosenClient,
                [infoIdentifier]: [...chosenClient[infoIdentifier]]
            }
            tempChosenClient[infoIdentifier].splice(index, 1);

            setChosenClient(tempChosenClient);
        }else{
            toast.error('Could not update client: undefined');
        }   
    };

    const removeChosenClientArrayAdditionalContact = (infoIdentifier, index, additionalIdentifier, additionalIndex) =>{
        console.log(infoIdentifier);
        console.log(index);
        console.log(additionalIdentifier);
        console.log(additionalIndex);
        if(chosenClient?.[infoIdentifier] !== undefined){
            let tempClient = {...chosenClient};
            let tempAddition = [...chosenClient[infoIdentifier][index][additionalIdentifier]];
            tempAddition.splice(additionalIndex, 1);

            const tempLocation = {
                ...tempClient[infoIdentifier][index],
                [additionalIdentifier]: [...tempAddition]
            }

            let tempLocations = [...tempClient[infoIdentifier]];
            tempLocations[index] = tempLocation;
            
            setChosenClient({
                ...tempClient,
                [infoIdentifier]: tempLocations
            });
        }else{
            toast.error('Could not update client: undefined');
        }  
    };

    const deleteChosenClient = async ()=>{
        if(chosenClient?.["Customer"] !== undefined && chosenClient?.["id"] !== undefined){
            try{
                await deleteDoc(doc(db, 'client_information', chosenClient["id"]));
                toast.success(`Successfully deleted: ${chosenClient["Customer"]}`)
                const clientIndex = findChosenClientIndexFromID(chosenClient.id);
                let tempClientInfo = [...clientInfo];
                tempClientInfo.splice(clientIndex, 1);
                
                setClientInfo(tempClientInfo);
                setChosenClient({id: ''});
                // reset dropdown selection to blank field
                if(locationDropDownDOM !== null){
                    locationDropDownDOM.reset();
                }

                setEmailTooltip('')
                setToolTipIndex(0)
                setEmailTooltipAdditional('');
                setToolTipIndexAdditional(0);
                setUpdateClientButtonStatus('edit')
            }catch(error){
                toast.error(`Could not delete ${chosenClient["Customer"]}: ${error.message}`)
            }
        }else{
            toast.error('Could not delete client: undefined');
        }
    };

    return(
        <>
            <Container fluid style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
                <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
                    <Row className="justify-content-center" style={{width:"100%"}}>
                        CLIENT INFORMATION
                    </Row>
                    <Row className="justify-content-center" style={{width:"100%", marginTop:10}}>
                        <Button 
                            className="btn-dark"
                            style={{backgroundColor:"#2596be", width:300}}
                            onClick={()=>{
                                setCreateClientModalShow(true)
                            }}
                        >
                            CREATE NEW CUSTOMER PROFILE
                        </Button>
                    </Row>
                </Container>
                <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%"}}>
                    <div className="w-100" style={{maxWidth: "600px"}}>
                        <div className="mt-3">
                            <Form ref={(form) => setLocationDropDownDOM(form)}>
                                <Form.Group  style={{textAlign:"left"}} id="set-client-list">
                                    <Form.Label>CUSTOMER PROFILE LIST:</Form.Label>
                                    <Form.Select onChange={(event)=>{
                                        setEmailTooltip('');
                                        setToolTipIndex(0);
                                        setEmailTooltipAdditional('');
                                        setToolTipIndexAdditional(0);
                                        setChosenClient(findChosenClientInfoFromID(event.target.value));
                                        setUpdateClientButtonStatus('edit')
                                    }}>
                                        {
                                            clientInfo.map((client, index)=>{
                                                return(
                                                    <option key={index} value={client.id}>
                                                        {client?.["Customer"] === undefined ? "" : client?.["Customer"]}
                                                    </option>
                                                )
                                            })
                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Container>
                <Container fluid className="mt-4">
                    <Row className="justify-content-md-center">
                        <Col lg="6">
                            <Card style={{border:"1px solid black"}}>
                                <Card.Header style={{textAlign:"center"}}>CUSTOMER INFORMATION</Card.Header>
                                <Card.Body style={{textAlign:"left"}}>
                                    <Row style={{marginLeft:"10px"}}><Col>CUSTOMER:</Col></Row>
                                    <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                value={chosenClient?.["Customer"] === undefined ? "" : chosenClient?.["Customer"]}
                                                onChange={(e)=>{updateChosenClient("Customer", e.target.value, "text")}}
                                                maxLength={inputMaxLengths.customer}
                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                    <Row style={{marginLeft:"10px"}}><Col>TRUCK CHARGE: $</Col></Row>
                                    <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                        <Col>
                                            <Form.Control
                                                type="number"
                                                value={chosenClient?.["Truck Charge"] === undefined ? "" : chosenClient?.["Truck Charge"]}
                                                onChange={(e)=>{updateChosenClient("Truck Charge", e.target.value, "number")}}
                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                    <Row style={{marginLeft:"10px"}}><Col>HOURLY RATE: $</Col></Row>
                                    <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                        <Col>
                                            <Form.Control
                                                type="number"
                                                value={chosenClient?.["Hourly Rate"] === undefined ? "" : chosenClient?.["Hourly Rate"]}
                                                onChange={(e)=>{updateChosenClient("Hourly Rate", e.target.value, "number")}}
                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                    <Row style={{marginLeft:"10px"}}><Col>PREMIUM HOURS RATE: $</Col></Row>
                                    <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                        <Col>
                                            <Form.Control
                                                type="number"
                                                value={chosenClient?.["Premium Hours"] === undefined ? "" : chosenClient?.["Premium Hours"]}
                                                onChange={(e)=>{updateChosenClient("Premium Hours", e.target.value, "number")}}
                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                    <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                        <Col>
                                            <Form.Check
                                                type="switch"
                                                id="premiumHoursSwitch"
                                                label={`Allow Premium Hours - ${chosenClient["Allow Premium Hours"] ? "On" : "Off"}`}
                                                checked = {chosenClient?.["Allow Premium Hours"] === undefined ? false : chosenClient["Allow Premium Hours"]}
                                                onChange={(e)=>{updateChosenClient("Allow Premium Hours", e.target.checked, "switch")}}
                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                    {/*
                                    <Row style={{marginLeft:"10px"}}><Col>INVOICES:</Col></Row>
                                    <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                        <Col>
                                        <Form.Select as="select" style={{width:400}} value={selectedInvoice} onChange={(e)=> setSelectedInvoice(e.target.value) } >
                                            <option value={``}>{``}</option>
                                            {
                                                chosenClient?.Invoices !== undefined &&
                                                chosenClient.Invoices.map((invoice)=>{
                                                return(
                                                    <option
                                                    key={invoice}
                                                    value={invoice}
                                                    >
                                                    {
                                                        invoice
                                                    }
                                                    </option>
                                                )
                                                })
                                            }
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    */}
                                </Card.Body>
                            </Card>
                        </Col>
                        
                    </Row>
                    <Row className="justify-content-md-center">
                        <Col lg="6">
                            <Card style={{border:"1px solid black"}}>
                                <Card.Header style={{textAlign:"center"}}>LOCATIONS: CONTACT INFORMATION</Card.Header>
                                <Card.Body style={{textAlign:"left"}}>
                                    <ol>
                                    {
                                        chosenClient?.["Locations"] === undefined  || chosenClient?.["Locations"].length === 0 ? 
                                            ""
                                        :
                                            chosenClient.Locations.map((location, index)=>{
                                                return(
                                                    <li key={index}>
                                                        <Row style={{marginLeft:"10px", marginBottom:"20px"}}>
                                                            <Row>
                                                                <Col>
                                                                    LOCATION: (SERVICE AT)
                                                                    {
                                                                        updateClientButtonStatus === 'save' ?
                                                                            <Button
                                                                                className="btn-dark"
                                                                                style={{backgroundColor:"#2596be", marginLeft:20, marginTop:20, width:60}}
                                                                                onClick={()=>{
                                                                                    if(window.confirm(`Are you sure you want to delete Location ${index+1}`)){
                                                                                        removeChosenClientArray('Locations', index);
                                                                                    }
                                                                                }}
                                                                                >
                                                                                <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                                                                            </Button>
                                                                        :
                                                                        ""
                                                                    }
                                                                </Col>
                                                            </Row>
                                                            <Row style={{marginBottom:"10px"}}>
                                                                <Col>
                                                                    <Form.Control
                                                                        className="mt-1"
                                                                        type="text"
                                                                        value={location?.["Address"] === undefined ? "" : location?.["Address"]}
                                                                        onChange={(e)=>{updateChosenClient("Address", e.target.value, "text", index)}}
                                                                        maxLength={inputMaxLengths.serviceAt}
                                                                        disabled={updateClientButtonStatus === 'edit' ? true : false}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row><Col>CONTACTS</Col></Row>
                                                            <ol type="A" style={{marginLeft:'10px'}}>
                                                                <li>
                                                                    <Row><Col>CLIENT NAME: (CUST. AUTHORIZATION/CONTACT)</Col></Row>
                                                                    <Row style={{marginBottom:"10px"}}>
                                                                        <Col>
                                                                            <Form.Control
                                                                                type="text"
                                                                                value={location?.["Client Name"] === undefined ? "" : location?.["Client Name"]}
                                                                                onChange={(e)=>{updateChosenClient("Client Name", e.target.value, "text", index)}}
                                                                                maxLength={inputMaxLengths.custAuthContact}
                                                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row><Col>EMAIL ADDRESS: (CUST. AUTHORIZATION/CONTACT EMAIL ADDRESS)</Col></Row>
                                                                    <Row style={{marginBottom:"10px"}}>
                                                                        <Col>
                                                                            <Form.Control
                                                                                type="text"
                                                                                value={location?.["Email Address"] === undefined ? "" : location?.["Email Address"]}
                                                                                onChange={(e)=>{
                                                                                    if (emailReg.test(e.target.value) === false && e.target.value !== '') {
                                                                                        setEmailTooltip('Not a valid email format, must have an @ sign and a .');
                                                                                        setToolTipIndex(index);
                                                                                    } else {
                                                                                        setEmailTooltip('');
                                                                                        setToolTipIndex(0);
                                                                                    }
                                                                                    updateChosenClient("Email Address", e.target.value, "text", index)
                                                                                }}
                                                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    {
                                                                        toolTipIndex === index ?
                                                                            <Row style={{color:'red', display:'flex', justifyContent:'center'}}>{emailTooltip}</Row>
                                                                        :
                                                                            ""
                                                                    }
                                                                    <Row><Col>PHONE NUMBER: (CUST. PHONE No.)</Col></Row>
                                                                    <Row style={{marginBottom:"10px"}}>
                                                                        <Col>
                                                                            <Form.Control
                                                                                type="text"
                                                                                value={location?.["Phone Number"] === undefined ? "" : location?.["Phone Number"]}
                                                                                onChange={(e)=>{updateChosenClient("Phone Number", e.target.value, "text", index)}}
                                                                                maxLength={inputMaxLengths.custPhoneNo}
                                                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                </li>
                                                                {
                                                                    location?.["Additional Contacts"] === undefined || location?.["Additional Contacts"].length === 0 ?
                                                                        ""
                                                                    :
                                                                    
                                                                        location["Additional Contacts"].map((additionContact, additionalIndex) =>{
                                                                            return(
                                                                                <li key={additionalIndex}>
                                                                                    <Row>
                                                                                        <Col>
                                                                                            CLIENT NAME:
                                                                                            {
                                                                                                updateClientButtonStatus === 'save' ?
                                                                                                    <Button
                                                                                                        className="btn-dark"
                                                                                                        style={{backgroundColor:"#2596be", marginLeft:20, marginTop:20, marginBottom: 20, width:60}}
                                                                                                        onClick={()=>{
                                                                                                            if(window.confirm(`Are you sure you want to delete Additional Contact ${additionContact?.["Client Name"]}`)){
                                                                                                                removeChosenClientArrayAdditionalContact('Locations', index, 'Additional Contacts', additionalIndex);
                                                                                                            }
                                                                                                        }}
                                                                                                        >
                                                                                                        <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                                                                                                    </Button>
                                                                                                :
                                                                                                ""
                                                                                            }
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row style={{marginBottom:"10px"}}>
                                                                                        <Col>
                                                                                            <Form.Control
                                                                                                type="text"
                                                                                                value={additionContact?.["Client Name"] === undefined ? "" : additionContact?.["Client Name"]}
                                                                                                onChange={(e)=>{updateChosenClientAdditionalContacts("Client Name", e.target.value, "text", index, additionalIndex)}}
                                                                                                maxLength={inputMaxLengths.custAuthContact}
                                                                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                                                                            />
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row><Col>EMAIL ADDRESS:</Col></Row>
                                                                                    <Row style={{marginBottom:"10px"}}>
                                                                                        <Col>
                                                                                            <Form.Control
                                                                                                type="text"
                                                                                                value={additionContact?.["Email Address"] === undefined ? "" : additionContact?.["Email Address"]}
                                                                                                onChange={(e)=>{
                                                                                                    if (emailReg.test(e.target.value) === false && e.target.value !== '') {
                                                                                                        setEmailTooltipAdditional('Not a valid email format, must have an @ sign and a .');
                                                                                                        setToolTipIndexAdditional(additionalIndex);
                                                                                                    } else {
                                                                                                        setEmailTooltipAdditional('');
                                                                                                        setToolTipIndexAdditional(0);
                                                                                                    }
                                                                                                    updateChosenClientAdditionalContacts("Email Address", e.target.value, "text", index, additionalIndex);
                                                                                                }}
                                                                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                                                                            />
                                                                                        </Col>
                                                                                    </Row>
                                                                                    {
                                                                                        toolTipIndexAdditional === additionalIndex ?
                                                                                            <Row style={{color:'red', display:'flex', justifyContent:'center'}}>{emailTooltipAdditional}</Row>
                                                                                        :
                                                                                            ""
                                                                                    }
                                                                                    <Row><Col>PHONE NUMBER:</Col></Row>
                                                                                    <Row style={{marginBottom:"10px"}}>
                                                                                        <Col>
                                                                                            <Form.Control
                                                                                                type="text"
                                                                                                value={additionContact?.["Phone Number"] === undefined ? "" : additionContact?.["Phone Number"]}
                                                                                                onChange={(e)=>{updateChosenClientAdditionalContacts("Phone Number", e.target.value, "text", index, additionalIndex)}}
                                                                                                maxLength={inputMaxLengths.custPhoneNo}
                                                                                                disabled={updateClientButtonStatus === 'edit' ? true : false}
                                                                                            />
                                                                                        </Col>
                                                                                    </Row>
                                                                                </li>
                                                                            )
                                                                        })
                                                                }
                                                            </ol>
                                                            {
                                                                updateClientButtonStatus === 'save' ?
                                                                    <Row>
                                                                        <Col style={{display:"flex", alignItems:"center", justifyContent:"right"}}>ADD CONCTACT</Col>
                                                                        <Col>
                                                                            <Button
                                                                                className="btn-dark"
                                                                                style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                                                                                onClick={()=>{
                                                                                    addChosenClientArrayAdditionalContact('Locations', index, 'Additional Contacts');
                                                                                }}
                                                                                >
                                                                                <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                                                                            </Button>
                                                                                
                                                                        </Col>
                                                                    </Row>
                                                                :
                                                                    ""
                                                            }
                                                            <Row><Col>TRUCK CHARGE: $ (LEAVE BLANK TO DEFAULT TO CUSTOMER INFO)</Col></Row>
                                                            <Row style={{marginBottom:"10px"}}>
                                                                <Col>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={location?.["Truck Charge"] === undefined || location?.["Truck Charge"] === null ? "" : location?.["Truck Charge"]}
                                                                        onChange={(e)=>{updateChosenClient("Truck Charge", e.target.value, "number", index)}}
                                                                        disabled={updateClientButtonStatus === 'edit' ? true : false}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row><Col>HOURLY RATE: $ (LEAVE BLANK TO DEFAULT TO CUSTOMER INFO)</Col></Row>
                                                            <Row style={{marginBottom:"10px"}}>
                                                                <Col>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={location?.["Hourly Rate"] === undefined || location?.["Hourly Rate"] === null ? "" : location?.["Hourly Rate"]}
                                                                        onChange={(e)=>{updateChosenClient("Hourly Rate", e.target.value, "number", index)}}
                                                                        disabled={updateClientButtonStatus === 'edit' ? true : false}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row><Col>PREMIUM HOURS RATE: $ (LEAVE BLANK TO USE DEFAULT)</Col></Row>
                                                            <Row style={{marginBottom:"10px"}}>
                                                                <Col>
                                                                    <Form.Control
                                                                        type="number"
                                                                        value={location?.["Premium Hours Rate"] === undefined || location?.["Premium Hours Rate"] === null ? "" : location?.["Premium Hours Rate"]}
                                                                        onChange={(e)=>{updateChosenClient("Premium Hours Rate", e.target.value, "number", index)}}
                                                                        disabled={updateClientButtonStatus === 'edit' ? true : false}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Row>
                                                    </li>
                                                )
                                            })
                                    }
                                    </ol>
                                    {
                                        updateClientButtonStatus === 'save' ?
                                            <Row>
                                                <Col style={{display:"flex", alignItems:"center", justifyContent:"right"}}>ADD LOCATION</Col>
                                                <Col>
                                                    <Button
                                                        className="btn-dark"
                                                        style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                                                        onClick={()=>{
                                                            addChosenClientArray('Locations');
                                                        }}
                                                        >
                                                        <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                                                    </Button>
                                                        
                                                </Col>
                                            </Row>
                                        :
                                            ""
                                    }
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <Container className='mt-3 mb-5'>
                    <Row>
                        {
                            chosenClient?.id === "" || chosenClient?.id === undefined ? 
                                ''
                            :
                                <div style={{display:'flex', flexDirection:"row", justifyContent:"center"}}>
                                    <Button
                                        className="btn-dark"
                                        style={{backgroundColor:"#2596be", width: 200, margin:5}}
                                        onClick={()=>{
                                            toggleClientButtonStatus()
                                        }}
                                    >
                                        {
                                            updateClientButtonStatus === 'edit' ? 'EDIT' : 'SAVE'

                                        }
                                    </Button>
                                    {
                                        updateClientButtonStatus === 'save' ? 
                                            <Button
                                                className="btn-dark"
                                                style={{backgroundColor:"#2596be", width: 200, margin:5}}
                                                onClick={()=>{
                                                    setEmailTooltip('')
                                                    setToolTipIndex(0)
                                                    setEmailTooltipAdditional('');
                                                    setToolTipIndexAdditional(0);
                                                    setChosenClient(findChosenClientInfoFromID(chosenClient.id))
                                                    setUpdateClientButtonStatus('edit')
                                                }}
                                            >
                                                CANCEL
                                            </Button>
                                        :
                                            ""
                                    }
                                </div>
                        }
                    </Row>
                    <Row>
                        {
                            chosenClient?.id === "" || chosenClient?.id === undefined ? 
                                ''
                            :
                            <div style={{display:'flex', flexDirection:"row", justifyContent:"center"}}>
                                {
                                    updateClientButtonStatus === 'save' ? 
                                        <Button
                                            className="btn-dark"
                                            style={{backgroundColor:"red", width: 600, margin:5}}
                                            onClick={()=>{
                                                if(chosenClient?.["Customer"] !== undefined){
                                                    if(window.confirm(`Are you sure you want to delete Client ${chosenClient?.["Customer"]}`)){
                                                        deleteChosenClient()
                                                    }else{
                                                        toast.info(`${chosenClient["Customer"]} was not deleted`)
                                                        setEmailTooltip('')
                                                        setToolTipIndex(0)
                                                        setEmailTooltipAdditional('');
                                                        setToolTipIndexAdditional(0);
                                                        setUpdateClientButtonStatus('edit')
                                                    }
                                                }else{
                                                    toast.warning('Client is undefined, cannot delete')
                                                    setEmailTooltip('')
                                                    setToolTipIndex(0)
                                                    setEmailTooltipAdditional('');
                                                    setToolTipIndexAdditional(0);
                                                    setUpdateClientButtonStatus('edit')
                                                }
                                                
                                            }}
                                        >
                                            DELETE CUSTOMER PROFILE AND ALL CONTACT INFORMATION
                                        </Button>
                                    :
                                        ""
                                }
                            </div>
                        }
                    </Row>
                </Container>
            </Container>
            {
                showSpinner &&
                <StatusSpinner />
            }
            <CreateClientModal
                show={createClientModalShow}
                onHide={(cancelBit, newClient={})=>{
                    if(cancelBit === 'show cancel'){
                        toast.warn(`Canceled: No client created.`);
                    }
                    if(cancelBit === 'new client'){
                        let tempClientInfo = [...clientInfo];
                        tempClientInfo.push(newClient)
                        setClientInfo(tempClientInfo)
                    }
                    setCreateClientModalShow(false);
                }}
            />
        </>
    )
}